export const ETRIS04_CurrentStock = {
  columns: 12,
  rows: 3,
  visual: {
    id: 1,
    type: "advancedTable",
    colorTheme: "colorTheme1",
    title: "Current Stocks",
    binding: {
      data: {
        columns: [
          {
            name: "Principal",
            columnName: "Principal",
            width: "150px",
            align: "left",
            sortable: true
          },
          {
            name: "Warehouse",
            columnName: "Warehouse",
            width: "150px",
            align: "left",
            sortable: true
          },
          {
            name: "Item Code",
            columnName: "ItemCode",
            width: "150px",
            align: "left",
            sortable: true
          },
          {
            name: "Item Description",
            columnName: "ItemDescription",
            width: "300px",
            align: "left",
            sortable: true
          },
          {
            name: "Unit Of Measure",
            columnName: "UnitOfMeasure",
            width: "180px",
            align: "center",
            sortable: true
          },
          {
            name: "Warehouse Location",
            columnName: "WarehouseLocation",
            width: "200px",
            align: "center",
            sortable: true
          },
          {
            name: "Expiry Date",
            columnName: "ExpiryDate",
            width: "180px",
            align: "left",
            sortable: true
          },
          {
            name: "Status",
            columnName: "Status",
            width: "120px",
            align: "left",
            sortable: true
          },
          {
            name: "Lot Number",
            columnName: "LotNumber",
            width: "150px",
            align: "left",
            sortable: true
          },
          {
            name: "Current Stock",
            columnName: "CurrentStock",
            width: "150px",
            align: "center",
            sortable: true
          },
          {
            name: "Allocated Stock",
            columnName: "AllocatedStock",
            width: "180px",
            align: "center",
            sortable: true
          },
          {
            name: "Total Remaining Stock",
            columnName: "TotalRemainingStock",
            width: "200px",
            align: "center",
            sortable: true
          },
          {
            name: "Item Group",
            columnName: "ItemGroup",
            width: "150px",
            align: "left",
            sortable: true
          },
          {
            name: "Classification",
            columnName: "Classification",
            width: "150px",
            align: "left",
            sortable: true
          }
        ],
        title: "Principal",
        onLoad: "Pgn.IS04",
        subtotal: true,
        pagination: {
          show: true
        },
        endpoint: "ETRIS04",
        parameters: [
          {
            key: "PageIndex",
            value: "1"
          },
          {
            key: "ResultsPerPage",
            value: "10"
          }
        ]
      },
      context: {
        point: {
          onClick: {}
        }
      }
    }
  }
};